import { FormControl } from '@axo/ui-core/components/form/FormControl';
import { MouseEventHandler, ReactNode } from 'react';
import { UIValidationState } from '../../models/state-to-ui-input-state';

export enum InfoType {
  ERROR = 'error',
  WARNING = 'warning',
  TOOLTIP = 'tooltip',
  SUCCESS = 'success',
}

interface IValidationPrompt {
  accept?: string;
  reject?: string;
}

export type IInputInfoBoxUI = {
  message?: ReactNode;
  prompt?: IValidationPrompt;
  children?: ReactNode;
  onAccept?: MouseEventHandler;
  onReject?: MouseEventHandler;
  type?: InfoType;
};

interface Props extends IInputInfoBoxUI {
  children?: ReactNode;
  infoId?: string;
  confirmationPrompt?: ReactNode;
}

export const InputInfoBoxUI = ({
  message,
  children,
  prompt,
  onAccept,
  onReject,
  type = InfoType.TOOLTIP,
  infoId,
  confirmationPrompt,
}: Props) => {
  return (
    <>
      {children}
      {type === InfoType.TOOLTIP && message && (
        <FormControl.Caption>{message}</FormControl.Caption>
      )}

      {type !== InfoType.TOOLTIP && (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <FormControl.Validation
            state={UIValidationState[type]}
            {...(onAccept &&
              onReject && { onConfirm: onAccept, onCancel: onReject })}
          >
            {message}
          </FormControl.Validation>
          {confirmationPrompt && <span>{confirmationPrompt}</span>}
        </div>
      )}
    </>
  );
};

export default InputInfoBoxUI;
